export enum WalletTab {
  Balance = 'balance',
  Deposit = 'deposit',
  Withdraw = 'withdraw',
}
